export default __webpack_public_path__ + "static/testimonials7-bcb5ad59bbecfcd905ba60f96031b75e.png";